import { render, staticRenderFns } from "./transactionsList.vue?vue&type=template&id=6f2b14a6&scoped=true"
import script from "./transactionsList.vue?vue&type=script&lang=js"
export * from "./transactionsList.vue?vue&type=script&lang=js"
import style0 from "./transactionsList.vue?vue&type=style&index=0&id=6f2b14a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2b14a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2b14a6')) {
      api.createRecord('6f2b14a6', component.options)
    } else {
      api.reload('6f2b14a6', component.options)
    }
    module.hot.accept("./transactionsList.vue?vue&type=template&id=6f2b14a6&scoped=true", function () {
      api.rerender('6f2b14a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/payment-link/components/tabs/transactionsList.vue"
export default component.exports